<template>
  <section  v-if="show">
    <div class="button-group">
      <ul
        class="setting-menu">
        <li
          v-for="(item,index) in list"
          :key="index"
          @click="handleSelect(item)"
        >
          <div

            class="with-icon">
            <i
              v-show="selectId==item.id"
              class="el-icon-check"></i>
          </div>
          <span>{{item.name}}</span>
        </li>
      </ul>
    </div>
  </section>
</template>

<script>
export default {
  name: 'selectGroup',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    list: {
      type: Array,
      default: ()=>([])
    },
    selectId: {
      type: [Number,String],
      default: ''
    },
  },
  data(){
    return{
      show:false
    }
  },
  watch: {
    value: {
      immediate: true,
      handler(val){
        this.show = val
      }
    },
  },
  methods:{
    handleSelect(item){
      this.$emit('select',item.id)
    }
  }
}
</script>

<style scoped lang="scss">
.setting-menu{
  list-style: none;
  background: #FFFFFF;
  //border: 1px solid #E1E4E8;
  border-radius: 6px;
  z-index: 100;
  margin-top: 10px!important;
  position: absolute;
  box-shadow: 0 1px 8px 0 rgba(27, 31, 35, 0.4);

  li{
    min-width: 136px;
    max-width: 256px;
    height: 33px;
    background: #FFFFFF;
    font-family: Inter;
    font-style: normal;
    font-weight: normal;
    font-size: 12px;
    line-height: 18px;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    color: #24292E!important;
    box-shadow: inset 0px -1px 0px #E1E4E8;
    cursor: pointer;
    &:first-child{
      border-top-right-radius: 10px;
      border-top-left-radius: 10px;
    }
    &:last-child{
      border-bottom-right-radius: 10px;
      border-bottom-left-radius: 10px;
    }
    .with-icon{
      width: 11px!important;
      margin-left: 10px;
    }
    i{
      width: 11px;
    }
    span{
      margin-left: 10px;
    }
    &:last-child{
      box-shadow: none!important;
    }
  }


}
</style>
